<template>
  <div id="app">
    <div v-if="formview">
      <PassportPage odd="both" >
        <template slot="content">
          <p class="slogan">Accélérez les contrôles, imprimez-vous un Passeport Traçabilité!</p>
          <p>Saisissez vos numéros d'immatriculation dans les champs ci-bas et appuyer sur Imprimer.</p>
          <div class="form-row">
            <div class="column col-center">
              <img v-if="no_trailer" src="@/assets/no-semi-vector.png" class="small-image">
              <img v-else src="@/assets/semi-vector.png" class="small-image">
              <input v-model="trailer" placeholder="Immatriculation Remorque" :disabled="no_trailer"/>
              <div class="checknlabel"><input type="checkbox" id="checkbox" v-model="no_trailer"><label class="small-text" for="checkbox">Ce véhicule n'a pas de remorque.</label></div>
            </div>
            <div class="column col-center">
              <img v-if="no_trailer" src="@/assets/dumptruck-vector.png" class="small-image">
              <img v-else src="@/assets/truck-vector.png" class="small-image">
              <input v-model="plates" :placeholder="'Immatriculation' + (no_trailer ? '':' Tracteur')" />
            </div>
          </div>
          <button v-on:click="formview = false" class="btn-submit" :disabled="(plates === '' || (!no_trailer && trailer === ''))">Imprimer</button>
        </template>
      </PassportPage>
    </div>
    <div v-else>
      <PassportPage :odd="no_trailer ? 'both':'odd'" >
        <template slot="content">
          <PassportContent :code="plates" :title="'IMMATRICULATION' + (no_trailer ? '':' TRACTEUR')">
            <template slot="details">
              <div class="img-container">
                <img v-if="no_trailer" src="@/assets/dumptruck-vector.png" class="truck-image">
                <img v-else src="@/assets/truck-vector.png" class="truck-image">
              </div>
            </template>
          </PassportContent>
        </template>
      </PassportPage>
      <br>
      <PassportPage v-if="!no_trailer" odd="even" >
        <template slot="content">
          <PassportContent :code="trailer" title="IMMATRICULATION REMORQUE">
            <template slot="details">
              <div class="img-container">
                <img src="@/assets/semi-vector.png" class="truck-image">
              </div>
            </template>
          </PassportContent>
        </template>
      </PassportPage>
    </div>
    <div v-show="false">
      <img src="@/assets/geot-hex.png"><img src="@/assets/optel-geot.png">
    </div>
  </div>
</template>

<script>
import PassportPage from "./components/PassportPage.vue";
import PassportContent from "./components/PassportContent.vue";
// import DriverDetails from "./components/DriverDetails.vue";


export default {
  name: 'app',
  components: {
    PassportPage,
    PassportContent,
    //DriverDetails
  },
  data: function() {
    return {
        formview: true,
        licence: '',
        plates: '',
        trailer: '',
        name: '',
        street_address: '',
        city: '',
        province: 'QC',
        postal_code: '',
        picture: '',
        no_trailer: true,
        imgs_loaded: 0
    };
  },
  mounted() {
      // if (localStorage.licence) {
      //   this.licence = localStorage.licence;
      // }
      // if (localStorage.plates) {
      //   this.plates = localStorage.plates;
      // }
      // if (localStorage.trailer) {
      //   this.trailer = localStorage.trailer;
      // }
      // if (localStorage.name) {
      //   this.name = localStorage.name;
      // }
      // if (localStorage.street_address) {
      //   this.street_address = localStorage.street_address;
      // }
      // if (localStorage.city) {
      //   this.city = localStorage.city;
      // }
      // if (localStorage.province) {
      //   this.province = localStorage.province;
      // }
      // if (localStorage.postal_code) {
      //   this.postal_code = localStorage.postal_code;
      // }
      // if (localStorage.picture) {
      //   this.picture = localStorage.picture;
      // }
      // if (localStorage.no_trailer) {
      //   this.no_trailer = localStorage.no_trailer;
      // }
      this.$eventHub.$on('qr_loaded', this.checkPrint);
  },
  watch: {
    // licence(value) {
    //   localStorage.licence = value;
    // },
    // plates(value) {
    //   localStorage.plates = value;
    // },
    // trailer(value) {
    //   localStorage.trailer = value;
    // },
    // no_trailer(value){
    //   localStorage.no_trailer = value;
    // },
    // name(value) {
    //   localStorage.name = value;
    // },
    // street_address(value) {
    //   localStorage.street_address = value;
    // },
    // city(value) {
    //   localStorage.city = value;
    // },
    // province(value) {
    //   localStorage.province = value;
    // },
    // postal_code(value) {
    //   localStorage.postal_code = value;
    // },
    // picture(value) {
    //   localStorage.picture = value;
    // }
  },
  methods : {
    checkPrint:  function () {
      var needed = (this.no_trailer ? 1:2);
      this.imgs_loaded += 1;
      if(this.imgs_loaded === needed) {
        window.print();   
      }
    }
  }
  // methods : {
  //   loadPhoto: function() {
  //     var FR= new FileReader();
  //     FR.onload = (e) => {
  //           this.picture = e.target.result;
  //     };       
  //     FR.readAsDataURL( this.$refs.photo.files[0] );
  //   },
  // }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 10px;
  width: 100%;
}

.checknlabel {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.slogan{
  font-size: 20px;
  margin-bottom: 20px;
}

button {
  background-color: #4CAF50;
  border: none;
  color: white;
  padding: 5px 15px;
  font-size: 16px;
  margin: 4px 7px;
  cursor: pointer;
  border-radius: 2px;
}

.small-text{
  color: #6E6E6E;
  font-size: 12px;
}

p {
  margin: 5px;
}

.form-qr-code{
  height: 125px;
  width: 125px;
  max-height: 125px;
  max-width: 125px;
  padding-bottom: 10px;
}

.img-container{
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content:center;
  align-items:center;
}

.form-row{
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.column{
  display: flex;
  flex-direction: column;
}

.col-center{
  height: 170px;
  width: 200px;
  align-items: center;
  align-content: flex-start;
}

.small-image {
  height: 90px;
  padding: 20px;
}

.truck-image {
  height:3.8cm;
}

.btn-submit {
  margin-top: 10px;
}
</style>
